import { BaseService } from "./BaseService";

export const CompraService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('compras/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas as compras:', error);
            return false;
        }
    },
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('compras/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir compra(s):', error);
            return false;
        }
    }, 
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`compras/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de processos de compras:', error);
            return false;
        }
    }, 
    async atribuirPlanos(id, postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost(`compras/${id}/atribuir-planos`, postData);
        } catch (error) {
            console.error('Ocorreu um erro ao atribuir planos de aquisição ao processo de compra:', error);
            return false;
        }
    },
    async buscarPlanos(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`compras/planos/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar os planos de aquisição do processo de compra:', error);
            return false;
        }
    },
    async buscarPlanosDisponiveis(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`compras/disponiveis/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar os planos de aquisição disponíveis:', error);
            return false;
        }
    }
}